import {createFileRoute} from '@tanstack/react-router'
import BlogPage from "../../landing/BlogPage.tsx";

export const Route = createFileRoute('/blog/$post_slug')({
    component: RouteComponent,
})

function RouteComponent() {
    return <BlogPage />
}
